'use strict';

import { translate } from '@core/i18n/window-language';

/**
 * Update tooltip content with translated text
 * @param {HTMLParagraphElement} tooltipDropdownContentText - The tooltip content text element
 * @param {number} tooltipContentWidth - The tooltip content width
 * @returns {void}
 */
export const updateTooltipContent = (tooltipDropdownContentText, tooltipContentWidth) => {
    tooltipDropdownContentText.innerText = translate('tooltip.similarImages');
    tooltipDropdownContentText.classList.add(
        tooltipContentWidth > 90 ? 'label-medium' : 'label-extra-small',
    );
};
